module.exports = __webpack_public_path__ + "img/icon-x.3fcfb34c.svg";